<div class="wrapper" [dir]="this.lang.getPageDirection()">
<div class="m-box">

    <h2>{{'appointments.sms-tracking.title' | translate}}</h2>
    <div class="title-row">
      <button class="btn-refresh" (click)="refresh()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        {{'appointments.sms-tracking.refresh' | translate}}
      </button>
    </div>

    <div class="date-picker-row">
      <label>{{'appointments.gui.labels.Date' | translate}}</label>
      <input
        type="date"
        [value]="selectedDate | date:'yyyy-MM-dd'"
        (input)="onDateChange($any($event.target).value)"
        class="date-input"
      />
    </div>

    <div *ngIf="smsData && !loading" class="info-bar">
      <div class="info-bar-text">
        <mat-icon style="vertical-align: middle; font-size: 1.2rem; margin-left: 0.3rem;">info</mat-icon>
        {{ 'appointments.sms-tracking.unique-note' | translate }}
      </div>
      <div *ngIf="(smsData.stats.duplicateReminders || 0) > 0" class="info-bar-duplicates">
        {{'appointments.sms-tracking.total-sent-label' | translate}} <strong>{{ smsData.stats.totalSmsSent || 0 }}</strong>
        <span style="margin-right: 0.5rem; color: #ff9800;">
          ({{ smsData.stats.duplicateReminders || 0 }} {{'appointments.sms-tracking.duplicate-reminders' | translate}})
        </span>
      </div>
    </div>

    <div class="stats-cards" *ngIf="smsData && !loading">
      <div class="stat-card">
        <div class="stat-value">{{ smsData.stats.uniqueAppointments || smsData.stats.totalSent }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.total' | translate}}</div>
      </div>
      <div class="stat-card cron-sent">
        <div class="stat-value">{{ smsData.stats.cronSent || 0 }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.auto' | translate}}</div>
      </div>
      <div class="stat-card manual-sent">
        <div class="stat-value">{{ smsData.stats.manualSent || 0 }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.manual' | translate}}</div>
      </div>
      <div class="stat-card success">
        <div class="stat-value">{{ smsData.stats.successful }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.success' | translate}}</div>
      </div>
      <div class="stat-card failed">
        <div class="stat-value">{{ smsData.stats.failed }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.failed' | translate}}</div>
      </div>
      <div class="stat-card deleted">
        <div class="stat-value">{{ smsData.stats.deleted }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.deleted' | translate}}</div>
      </div>
      <div class="stat-card changed">
        <div class="stat-value">{{ smsData.stats.dateChanged }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.date-changed' | translate}}</div>
      </div>
      <div class="stat-card no-change">
        <div class="stat-value">{{ smsData.stats.noChanges }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.no-changes' | translate}}</div>
      </div>
      <div class="stat-card arrival-sms">
        <div class="stat-value">{{ smsData.stats.confirmedViaSMS }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.confirmed-sms' | translate}}</div>
      </div>
      <div class="stat-card declined-sms">
        <div class="stat-value">{{ smsData.stats.declinedViaSMS }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.declined-sms' | translate}}</div>
      </div>
      <div class="stat-card arrival-user">
        <div class="stat-value">{{ smsData.stats.arrivedViaUser }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.confirmed-user' | translate}}</div>
      </div>
      <div class="stat-card not-arrived">
        <div class="stat-value">{{ smsData.stats.noResponse }}</div>
        <div class="stat-label">{{'appointments.sms-tracking.stat.waiting' | translate}}</div>
      </div>
    </div>
 

  <div class="filters-section">
    <div class="filter-group">
      <label>{{'appointments.sms-tracking.filter.sms-status' | translate}}</label>
      <select [(ngModel)]="filterStatus" (change)="onFilterChange()">
        <option value="all">{{'appointments.gui.selects.All' | translate}}</option>
        <option value="success">{{'appointments.sms-tracking.filter.success' | translate}}</option>
        <option value="failed">{{'appointments.sms-tracking.filter.failed' | translate}}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>{{'appointments.sms-tracking.filter.send-type' | translate}}</label>
      <select [(ngModel)]="filterSendType" (change)="onFilterChange()">
        <option value="all">{{'appointments.gui.selects.All' | translate}}</option>
        <option value="cron">{{'appointments.sms-tracking.filter.auto' | translate}}</option>
        <option value="manual">{{'appointments.sms-tracking.filter.manual' | translate}}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>{{'appointments.gui.labels.Changes' | translate}}</label>
      <select [(ngModel)]="filterChanges" (change)="onFilterChange()">
        <option value="all">{{'appointments.gui.selects.All' | translate}}</option>
        <option value="deleted">{{'appointments.sms-tracking.filter.deleted' | translate}}</option>
        <option value="dateChanged">{{'appointments.sms-tracking.filter.date-changed' | translate}}</option>
        <option value="noChanges">{{'appointments.sms-tracking.filter.no-changes' | translate}}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>{{'appointments.sms-tracking.filter.arrival-status' | translate}}</label>
      <select [(ngModel)]="filterArrival" (change)="onFilterChange()">
        <option value="all">{{'appointments.gui.selects.All' | translate}}</option>
        <option value="confirmedUser">{{'appointments.sms-tracking.arrival.confirmed-user' | translate}}</option>
        <option value="confirmedSMS">{{'appointments.sms-tracking.arrival.confirmed-patient' | translate}}</option>
        <option value="cancelledSMS">{{'appointments.sms-tracking.arrival.declined-patient' | translate}}</option>
        <option value="waiting">{{'appointments.sms-tracking.arrival.waiting' | translate}}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>{{'billing.gui.labels.Exam Name' | translate}}</label>
      <select [(ngModel)]="filterExamType" (change)="onFilterChange()">
        <option [ngValue]="'all'">{{'appointments.gui.selects.All' | translate}}</option>
        <option *ngFor="let exam of getUniqueExamTypes()" [ngValue]="exam.id">{{ exam.name }}</option>
      </select>
    </div>

    <div class="filter-group">
      <label>{{'appointments.gui.buttons.Search' | translate}}</label>
      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="onFilterChange()"
        [placeholder]="'appointments.sms-tracking.filter.search-placeholder' | translate"
        class="search-input"
      />
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>{{'appointments.sms-tracking.loading' | translate}}</p>
  </div>

  <div *ngIf="error" class="error-message">
    <mat-icon>error</mat-icon>
    {{ error }}
  </div>

  <div *ngIf="!loading && !error && filteredRecords.length > 0" class="table-container">
    <table class="sms-table">
      <thead>
        <tr>
          <th>{{'appointments.gui.labels.status' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.send-type' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.sent-time' | translate}}</th>
          <th>{{'appointments.gui.labels.Patient ID' | translate}}</th>
          <th>{{'appointments.gui.labels.Phone' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.apt-time' | translate}}</th>
          <th>{{'appointments.gui.labels.Exam Type' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.arrival' | translate}}</th>
          <th>{{'appointments.gui.labels.Changes' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.link' | translate}}</th>
          <th>{{'appointments.sms-tracking.col.details' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of filteredRecords" [ngClass]="getRowClass(record)">
          <td class="status-cell">
            <mat-icon [class.success-icon]="record.answerMessage === 'SMS will be sent'"
                      [class.error-icon]="record.answerMessage !== 'SMS will be sent'">
              {{ getStatusIcon(record) }}
            </mat-icon>
          </td>
          <td>
            <span class="send-type-badge"
                  [class.cron]="isCronJobMessage(record)"
                  [class.manual]="!isCronJobMessage(record)">
              {{ getSendTypeBadge(record) }}
            </span>
          </td>
          <td>{{ formatDateTime(record.smsSentTime) }}</td>
          <td>{{ record.patientID || 'N/A' }}</td>
          <td>{{ record.mobile }}</td>
          <td>{{ formatDateTime(record.originalAptTime) }}</td>
          <td>{{ getExamName(record.examType) }}</td>
          <td class="arrival-cell">
            <div class="arrival-status"
                 [class.confirmed-user]="record.arrivalConfirmedViaUser"
                 [class.confirmed-patient]="record.arrivalConfirmedViaSMS && !record.arrivalConfirmedViaUser && record.arrivalConfirm === true"
                 [class.declined-patient]="record.arrivalConfirmedViaSMS && !record.arrivalConfirmedViaUser && record.arrivalConfirm === false"
                 [class.not-confirmed]="!record.arrivalConfirmedViaSMS && !record.arrivalConfirmedViaUser">
              <mat-icon>{{ getArrivalIcon(record) }}</mat-icon>
              <span>{{ getArrivalStatus(record) }}</span>
              <small *ngIf="getArrivalDate(record)" class="arrival-date">
                {{ formatDateTime(getArrivalDate(record)!) }}
              </small>
            </div>
          </td>
          <td>
            <span class="changes-badge"
                  [class.deleted]="record.wasDeleted"
                  [class.changed]="record.dateChanged"
                  [class.no-change]="!record.wasDeleted && !record.dateChanged">
              {{ getChangesBadge(record) }}
            </span>
          </td>
          <td class="link-cell">
            <button class="btn-link"
                    [matTooltip]="'appointments.sms-tracking.tooltip.copy-sms' | translate"
                    (click)="copySmsMessage(record)">
              <mat-icon>sms</mat-icon>
            </button>
          </td>
          <td>
            <button class="btn-details"
                    [matTooltip]="'appointments.sms-tracking.tooltip.details' | translate"
                    (click)="showDetails(record)">
              <mat-icon>info</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && !error && filteredRecords.length === 0" class="no-data">
    <mat-icon>inbox</mat-icon>
    <p>{{'appointments.sms-tracking.no-data' | translate}}</p>
  </div>
 </div>
</div>
